enum CouponDuration {
    ONCE = 'once',
    REPEATING = 'repeating',
    FOREVER = 'forever',
}

export default CouponDuration;
